import Armature from '../../Armature';

export default class Gold extends Armature {
    public create(params: any): void {
        super.create({
            name: 'goldContainer',
            dragonbonesName: 'CardsVFX',
            armatureName: 'GoldCard',
            animationName: 'GoldCard_Idle',
            playOnStart: true,
            visible: false,
            ...params,
        });
    }
}
